import React from 'react';
import { makeStyles } from '@material-ui/core';
import { oprolsysteem, bedrukker, bedrukker10, bedrukker15, coronabehandeling, microperforatie, rillijnen, snijlijnen, waving } from '../../Config/constants'

export default function BOLImagesComponent(props) {
    const classes = useStyles();

    let imageSources = []
    var i;
    for (i = 0; i < props.bolMetaData.length; i++) {
        switch (props.bolMetaData[i].Name) {

            case bedrukker:
                imageSources.push(process.env.PUBLIC_URL + '/img/afdrukken.svg')
                break;
            case bedrukker10:
                imageSources.push(process.env.PUBLIC_URL + '/img/afdrukken10.svg')
                break;
            case bedrukker15:
                imageSources.push(process.env.PUBLIC_URL + '/img/afdrukken15.svg')
                break;
            case microperforatie:
                imageSources.push(process.env.PUBLIC_URL + '/img/microperforatie.svg')
                break;
            case coronabehandeling:
                imageSources.push(process.env.PUBLIC_URL + '/img/coronabehandeling.svg')
                break;
            case snijlijnen:
                imageSources.push(process.env.PUBLIC_URL + '/img/snijlijnen.svg')
                break;
            case oprolsysteem:
                imageSources.push(process.env.PUBLIC_URL + '/img/oprollen.svg')
                break;
            case rillijnen:
                imageSources.push(process.env.PUBLIC_URL + '/img/rillijnen.svg')
                break;
            case waving:
                imageSources.push(process.env.PUBLIC_URL + '/img/waving.svg')
                break;
            default:
        }
    }

    return (
        <div className={classes.container}>
            {imageSources.map(x => <img className={classes.img} alt={x} src={x} key={x}></img>)}
        </div>
    )

}

const useStyles = makeStyles(() => ({
    container: {

    },
    img: {
        float: "right",
        height: "45px",
        marginLeft: "10px"
    }
}));